"use client";
import { ReactNode } from "react";
import { useEffect, useState } from "react";
// import "./layout.css";
import { useQuery } from "react-query";
import PAGE_SETTING_API from "./api";
import { IconExclamationCircle, IconPhoneCall, IconPhoneFilled, IconMail } from "@tabler/icons-react";

interface TimeLeft {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

const ProviderMaintananceMode = ({ children }: { children: ReactNode }) => {
  const now  = new Date()
  const [isMaintanance, setIsMaintanance] = useState(false);
  const [timeChange, setTimeChange] = useState(now.setDate(now.getDate()+1));

  const { data: maintananceMode } = useQuery({
    queryKey: ["maintanance-mode-page-setting"],
    queryFn: () => PAGE_SETTING_API.GET_PAGE_SETTING("MAINTANANCE MODE"),
    enabled: true,
    refetchOnWindowFocus: false,
  });

  const { data: whiteListIp } = useQuery({
    queryKey: ["WhiteListIp"],
    queryFn: () => PAGE_SETTING_API.GET_WHITELIST_IP(),
    enabled: true,
    refetchOnWindowFocus: false,
  });

  const calculateTimeLeft = (time: number): TimeLeft => {
    const targetDate = new Date(time)
    const difference = targetDate.getTime() - new Date().getTime();

    let timeLeft: TimeLeft = {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    };

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState<TimeLeft>(
    calculateTimeLeft(timeChange)
  );

  undefined

  useEffect(() => {
    const timer = setInterval(() => {
      const target = new Date(maintananceMode?.estimate_change)
      setTimeChange(target.getTime())
      setTimeLeft(
        calculateTimeLeft(
          target.getTime()
        )
      );
    }, 1000);

    return () => clearInterval(timer);
  }, [maintananceMode]);

  useEffect(() => {
    const getClientIp = async () => {
      const res = await fetch("/api/client-ip");
      const data = await res.json();
      if (whiteListIp) {
        if (maintananceMode?.is_active) {
          setIsMaintanance(true);
          if (whiteListIp.length > 0) {
            whiteListIp.some((element: { ip: string }) => {
              if (element.ip == data.ip) {
                setIsMaintanance(false);
                return true;
              } else {
                return false;
              }
            });
          }
        }
      }
    };

    getClientIp();
  }, [whiteListIp, maintananceMode]);

  if (isMaintanance) {
    return (
      <div className="grid grid-cols-2">
        <div className="col-span-1 min-h-screen flex flex-col items-center justify-center bg-white text-center px-4">
          <h1 className="text-4xl md:text-5xl font-bold text-indigo-900 mb-2">
            {maintananceMode.title}
          </h1>
          <h2 className="text-2xl font-semibold text-indigo-800 mb-6">
            {maintananceMode.sub_title}
          </h2>
          <p className="text-gray-600 mb-1 w-1/2">
            {maintananceMode.description}
          </p>

          <div className="flex mt-2 space-x-6 text-indigo-800 text-3xl font-bold mb-8">
            <div>
              <div>{timeLeft.days}</div>
              <div className="text-sm text-gray-500">DAYS</div>
            </div>
            <div>
              <div>{String(timeLeft.hours).padStart(2, "0")}</div>
              <div className="text-sm text-gray-500">HOURS</div>
            </div>
            <div>
              <div>{String(timeLeft.minutes).padStart(2, "0")}</div>
              <div className="text-sm text-gray-500">MINUTES</div>
            </div>
            <div>
              <div>{String(timeLeft.seconds).padStart(2, "0")}</div>
              <div className="text-sm text-gray-500">SECONDS</div>
            </div>
          </div>

          <div className="flex space-x-4 text-xl">
            <a href="#" className="flex items-center gap-1  hover:scale-110 transition">
              <IconPhoneFilled  size={30} color="#312e81" className="m-auto" />
              <span className="text-indigo-900 text-sm font-semibold">{maintananceMode?.phone}</span>
              
            </a>
            {maintananceMode?.email.length > 0 && <a href="#" className="flex items-center gap-1  hover:scale-110 transition">
              <IconMail  size={30} color="#312e81" className="m-auto" />
              <span className="text-indigo-900 text-sm font-semibold">{maintananceMode?.email}</span>
            </a>}
          </div>
        </div>
        <div className="col-span-1">
          <div className="full-parent-maintanance-bg"></div>
        </div>
      </div>
      // <div className="min-h-screen flex flex-col items-center justify-center bg-white text-center px-4">
      //   <h1 className="text-4xl md:text-5xl font-bold text-indigo-900 mb-2">{maintananceMode.title}</h1>
      //   <h2 className="text-2xl font-semibold text-indigo-800 mb-6">{maintananceMode.sub_title}</h2>
      //   <p className="text-gray-600 mb-1 w-1/4">{maintananceMode.description}</p>

      //   <div className="flex space-x-6 text-indigo-800 text-xl font-bold mb-8">
      //     <div>
      //       <div>{timeLeft.days}</div>
      //       <div className="text-sm text-gray-500">DAYS</div>
      //     </div>
      //     <div>
      //       <div>{String(timeLeft.hours).padStart(2, '0')}</div>
      //       <div className="text-sm text-gray-500">HOURS</div>
      //     </div>
      //     <div>
      //       <div>{String(timeLeft.minutes).padStart(2, '0')}</div>
      //       <div className="text-sm text-gray-500">MINUTES</div>
      //     </div>
      //     <div>
      //       <div>{String(timeLeft.seconds).padStart(2, '0')}</div>
      //       <div className="text-sm text-gray-500">SECONDS</div>
      //     </div>
      //   </div>

      //   <div className="flex space-x-4 text-2xl">
      //     <a href="#" className="text-blue-500 hover:scale-110 transition"><i className="fab fa-facebook-f"></i></a>
      //     <a href="#" className="text-sky-400 hover:scale-110 transition"><i className="fab fa-twitter"></i></a>
      //     <a href="#" className="text-pink-500 hover:scale-110 transition"><i className="fab fa-instagram"></i></a>
      //     <a href="#" className="text-blue-700 hover:scale-110 transition"><i className="fab fa-linkedin-in"></i></a>
      //     <a href="#" className="text-red-600 hover:scale-110 transition"><i className="fab fa-youtube"></i></a>
      //   </div>
      // </div>
    );
    // return <div className="flex justify-center">
    //   <div className="full-screen-maintanance-bg "></div>
    // </div>
  }

  return <>{children}</>;
};

export default ProviderMaintananceMode;
